import { render, staticRenderFns } from "./ShowCoursesPage.vue?vue&type=template&id=790d4664&scoped=true&"
import script from "./ShowCoursesPage.vue?vue&type=script&lang=js&"
export * from "./ShowCoursesPage.vue?vue&type=script&lang=js&"
import style0 from "./ShowCoursesPage.vue?vue&type=style&index=0&id=790d4664&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790d4664",
  null
  
)

export default component.exports